import React from 'react'
import { MDXProvider } from '@mdx-js/react'
import './src/styles/global.css'

// Import MDX components
import Card from './src/components/mdx/Card'
import Alert from './src/components/mdx/Alert'
import Button from './src/components/mdx/Button'
import YouTubeEmbed from './src/components/mdx/YouTubeEmbed'
import InstagramEmbed from './src/components/mdx/InstagramEmbed'
import { Columns, Column } from './src/components/mdx/Columns'
import { Accordion, AccordionItem } from './src/components/mdx/Accordion'
import StatementsList from './src/components/mdx/StatementsList'
import LatestStatement from './src/components/mdx/LatestStatement'
import AuthorStatement from './src/components/mdx/AuthorStatement'
import SocietiesList from './src/components/mdx/SocietiesList'
import FeaturedSocieties from './src/components/mdx/FeaturedSocieties'
import CommitteeList from './src/components/mdx/CommitteeList'
import CoursesList from './src/components/mdx/CoursesList'
import Divider from './src/components/mdx/Divider'
import Document from './src/components/mdx/Document'
import Calendar from './src/components/mdx/Calendar'
import MicrosoftForm from './src/components/mdx/MicrosoftForm'
import GoogleForm from './src/components/mdx/GoogleForm'
import MinutesList from './src/components/mdx/MinutesList'
import CookieSettings from './src/components/mdx/CookieSettings'

// Define components available in MDX
const mdxComponents = {
  Card: Card,
  Alert: Alert,
  Button: Button,
  YouTubeEmbed: YouTubeEmbed,
  InstagramEmbed: InstagramEmbed,
  Columns: Columns,
  Column: Column,
  Accordion: Accordion,
  AccordionItem: AccordionItem,
  StatementsList: StatementsList,
  LatestStatement: LatestStatement,
  AuthorStatement: AuthorStatement,
  SocietiesList: SocietiesList,
  FeaturedSocieties: FeaturedSocieties,
  CommitteeList: CommitteeList,
  CoursesList: CoursesList,
  Divider: Divider,
  Document: Document,
  Calendar: Calendar,
  MicrosoftForm: MicrosoftForm,
  GoogleForm: GoogleForm,
  MinutesList: MinutesList,
  CookieSettings: CookieSettings
}

// Wrap the root element with MDXProvider
export const wrapRootElement = ({ element }) => (
  <MDXProvider components={mdxComponents}>
    {element}
  </MDXProvider>  
)